import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { T as Typography } from './Typography-BUVIUAC9.js';

var styles = {"button":"U9VsquOtk2I-","work":"qkFQwI0PKfw-","learning":"jsKQEOBdJ0k-","subtle":"vDKO-cmh8vY-","destructive":"_4W8X0dxZDK4-","primary":"FXqN12jWtPo-","disabled":"bg-l22drjd0-","secondary":"pf6G840lKdA-","tertiary":"m7DbwRZWcNk-","small":"STSDgSRREx4-","base":"amIh7vPETfo-","large":"ON6ezOojFVo-","onlyIcon":"Qq-idRLJTCk-","hasIconAndLabel":"EWh1gvgPJQg-","iconOnRight":"pfzTUMgNb3o-","fullWidth":"ZCHqCEyLBw0-","loading":"VVFKEv1ksMA-","animateStripes":"a8Q-0lnKH5M-"};

function Button(props) {
    const { ariaControls, ariaHaspopup, ariaExpanded, ariaLabel, disabled = false, external, fullWidth, icon, label, iconOnRight, id, loading, onClick, onMouseDown, role, size = "base", type = "primary", url, to, variation = "work", submit, } = props;
    const buttonClassNames = classnames(styles.button, styles[size], {
        [styles.onlyIcon]: icon && !label,
        [styles.hasIconAndLabel]: icon && label,
        [styles.iconOnRight]: iconOnRight,
        [styles[variation]]: variation,
        [styles[type]]: type,
        [styles.disabled]: disabled,
        [styles.fullWidth]: fullWidth,
        [styles.loading]: loading,
    });
    const buttonType = submit ? "submit" : "button";
    const tagProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ className: buttonClassNames, disabled,
        id }, (!disabled && { href: url })), (!disabled && { onClick: onClick })), (!disabled && { onMouseDown: onMouseDown })), (external && { target: "_blank" })), (url === undefined && to === undefined && { type: buttonType })), { "aria-controls": ariaControls, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded, "aria-label": ariaLabel, role: role });
    const buttonInternals = React.createElement(ButtonInternals, Object.assign({}, props));
    if (to) {
        return (React.createElement(Link, Object.assign({}, tagProps, { to: to }), buttonInternals));
    }
    const Tag = url ? "a" : "button";
    return React.createElement(Tag, Object.assign({}, tagProps), buttonInternals);
}
function ButtonInternals({ label, icon, size = "base" }) {
    return (React.createElement(React.Fragment, null,
        icon && React.createElement(Icon, { name: icon, size: size }),
        React.createElement(Typography, { element: "span", fontWeight: "semiBold", fontFamily: "base", size: getTypeSizes(size) }, label)));
}
function getTypeSizes(size) {
    switch (size) {
        case "small":
            return "base";
        case "large":
            return "large";
        default:
            return "base";
    }
}

export { Button as B };
